const fiberCities = [
	{uf: 'MG', name: 'VESPASIANO', type: 'fibraX', nameNormalized: 'vespasiano'},
	{uf: 'MG', name: 'SABARÁ', type: 'fibraX', nameNormalized: 'sabara'},
	{uf: 'MG', name: 'NOVA LIMA', type: 'fibraX', nameNormalized: 'nova lima'},
	{uf: 'MG', name: 'IBIRITÉ', type: 'fibraX', nameNormalized: 'ibirite'},
	{uf: 'MG', name: 'CONTAGEM', type: 'fibraX', nameNormalized: 'contagem'},
	{uf: 'MG', name: 'BETIM', type: 'fibraX', nameNormalized: 'betim'},
	{uf: 'PA', name: 'ANANINDEUA', type: 'fibraX', nameNormalized: 'ananindeua'},
	{uf: 'PE', name: 'OLINDA', type: 'fibraX', nameNormalized: 'olinda'},
	{uf: 'PR', name: 'PINHAIS', type: 'fibraX', nameNormalized: 'pinhais'},
	{uf: 'PR', name: 'COLOMBO', type: 'fibraX', nameNormalized: 'colombo'},
	{
		uf: 'RS',
		name: 'ELDORADO DO SUL',
		type: 'fibraX',
		nameNormalized: 'eldorado do sul'
	},
	{uf: 'SC', name: 'RIO DO SUL', type: 'fibraX', nameNormalized: 'rio do sul'},
	{uf: 'SC', name: 'LAGES', type: 'fibraX', nameNormalized: 'lages'},
	{uf: 'SC', name: 'ITUPORANGA', type: 'fibraX', nameNormalized: 'ituporanga'},
	{uf: 'SC', name: 'GUABIRUBA', type: 'fibraX', nameNormalized: 'guabiruba'},
	{uf: 'SC', name: 'CRICIÚMA', type: 'fibraX', nameNormalized: 'criciuma'},
	{uf: 'SC', name: 'CHAPECÓ', type: 'fibraX', nameNormalized: 'chapeco'},
	{
		uf: 'SC',
		name: 'BALNEÁRIO CAMBORIÚ',
		type: 'fibraX',
		nameNormalized: 'balneario camboriu'
	},
	{uf: 'AM', name: 'MANAUS', type: 'fibraxp', nameNormalized: 'manaus'},
	{
		uf: 'MG',
		name: 'BELO HORIZONTE',
		type: 'fibraxp',
		nameNormalized: 'belo horizonte'
	},
	{
		uf: 'MS',
		name: 'CAMPO GRANDE',
		type: 'fibraxp',
		nameNormalized: 'campo grande'
	},
	{uf: 'MT', name: 'CUIABÁ', type: 'fibraxp', nameNormalized: 'cuiaba'},
	{uf: 'PE', name: 'RECIFE', type: 'fibraxp', nameNormalized: 'recife'},
	{uf: 'PR', name: 'MARINGÁ', type: 'fibraxp', nameNormalized: 'maringa'},
	{
		uf: 'RJ',
		name: 'RIO DE JANEIRO',
		type: 'fibraxp',
		nameNormalized: 'rio de janeiro'
	},
	{uf: 'RN', name: 'NATAL', type: 'fibraxp', nameNormalized: 'natal'},
	{
		uf: 'RS',
		name: 'CAXIAS DO SUL',
		type: 'fibraxp',
		nameNormalized: 'caxias do sul'
	},
	{uf: 'SC', name: 'ITAJAÍ', type: 'fibraxp', nameNormalized: 'itajai'},
	{
		uf: 'SC',
		name: 'FLORIANÓPOLIS',
		type: 'fibraxp',
		nameNormalized: 'florianopolis'
	}
];

